import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchAnnouncementGroups } from 'redux/slices/announcements/announcementGroupSlice';
import { AppDispatch, RootState } from 'redux/store';
import { AnnouncementGroupsAutocompleteProps } from 'types/autocomplete';
import Autocomplete from 'components/Common/Autocomplete';
import AutocompleteOption from 'components/Common/autocomplete/AutocompleteOption';
import { AnnouncementGroup } from 'types/announcements';

const AnnouncementGroupAutocomplete = ({ defaultValue, setGroup, ...props }: AnnouncementGroupsAutocompleteProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { loading = false, records = [] } = useSelector((state: RootState) => state.announcement.announcementGroups);
    if (defaultValue && typeof defaultValue !== 'object') {
        const group = records.find((g) => String(g.id) === String(defaultValue));
        if (group) {
            defaultValue = group;
        }
    }

    useEffect(() => {
        if (!defaultValue) {
            dispatch(fetchAnnouncementGroups());
        }
    }, [dispatch, defaultValue]);

    return (
        <Autocomplete
            loading={loading}
            label="To"
            placeholder="Announcement Groups"
            options={records}
            disabled={!!defaultValue}
            onChange={(_: any, value: AnnouncementGroup) => setGroup(value)}
            defaultValue={defaultValue}
            getOptionLabel={(option) => option?.title}
            renderOption={(props: any, option: any) => {
                const { title: name, contact: email, imgUrl } = option;
                const _option = { name, email, imgUrl };
                return <AutocompleteOption option={_option} props={props} />;
            }}
            getOptionKey={(option) => (typeof option === 'object' ? option?.id : option)}
            {...props}
        />
    );
};

export default AnnouncementGroupAutocomplete;
